export default __webpack_public_path__ + "static/chicken_escape_banner-b51e1f1020f761f219e01b521f98a8cc.jpg";